import Hero from "../components/Hero";
import HeroImage from "../../assets/images/Blogs1.jpg";
import BlogCard from "../designSystem/BlogCard";
import blog1 from "../../assets/images/blogs/Blog1.png";
import blog2 from "../../assets/images/blogs/Blog4.png";
import blog3 from "../../assets/images/blogs/Blog3.png";
import blog4 from "../../assets/images/blogs/Blog4.png";
import blog5 from "../../assets/images/blogs/Blog5.png";
import blog6 from "../../assets/images/blogs/Blog6.png";
import blog7 from "../../assets/images/blogs/Blog7.png";
import blog8 from "../../assets/images/blogs/Blog8.png";
import blog9 from "../../assets/images/blogs/Blog9.png";

const blogs = [
  {
    title:
      "Unveiling Conditional Selling: A Wake-Up Call for the UK Property Market",
    image: blog9,
    datePosted: "Jul 17, 2025",
    description:
      'A recent undercover investigation by BBC Panorama has shed light on concerning practices within the UK estate agency sector. The investigation revealed instances of "conditional selling," where estate agents allegedly prioritise buyers who commit to using in-house...',
    link: "/blogs9",
  },
  {
    title:
      "Everything You Need to Know About Moving Home and Mortgages: A Complete Guide",
    image: blog8,
    datePosted: "Jul 3, 2025",
    description:
      "Moving home is an exciting new chapter in life, but it can also be a stressful process—especially when it comes to managing your mortgage. Whether you're a first-time buyer, remortgaging, or moving to a new home, understanding your mortgage options and the steps...",
    link: "/blogs8",
  },
  {
    title:
      "Bank of England Holds Interest Rates: What Does This Mean for Your Mortgage?",
    image: blog7,
    datePosted: "Jun 19, 2025",
    description:
      "The Bank of England recently announced that it will keep interest rates on hold as it continues to monitor inflation and the broader global economic outlook. This decision comes at a time when many homeowners, buyers, and investors are closely watching the central...",
    link: "/blogs7",
  },
  {
    title: "The Bank of Mum, Dad, Son, or Daughter: Helping with Mortgages",
    image: blog6,
    datePosted: "May 29, 2025",
    description:
      "In today’s housing market, many families are coming together to support one another financially, especially when it comes to buying a home or paying off a mortgage. Whether it’s the Bank of Mum and Dad, Son, or Daughter, more and more families are finding themselves in...",
    link: "/blogs6",
  },
  {
    title: "The Risks and Rewards of 100% Mortgages: What You Need to Know",
    image: blog5,
    datePosted: "May 22, 2025",
    description:
      "In recent years, the UK mortgage market has seen fluctuations in the availability of lending products. Among the most significant developments is the return of 100% mortgages—loans where the borrower is not required to pay any deposit upfront. While this may sound...",
    link: "/blogs5",
  },
  {
    title:
      "Why You Should Work with a Mortgage Adviser: A Step Toward Stress-Free Homeownership",
    image: blog4,
    datePosted: "May 13, 2025",
    description:
      "Buying a home is one of the most significant financial decisions you'll ever make. Whether it’s your first home, a new property, or a remortgage, navigating the complex world of mortgages can feel overwhelming. With so many options, rates, and terms to consider, it’s...",
    link: "/blogs4",
  },
  {
    title:
      "Understanding the First Homes Scheme: A Helping Hand for First-Time Buyers",
    image: blog3,
    datePosted: "May 1, 2025",
    description:
      "The journey to homeownership can be a challenging one, particularly for first-time buyers who are trying to save for a deposit while dealing with rising property prices. The UK government has introduced the First Homes Scheme to help make homeownership more affordable...",
    link: "/blogs3",
  },
  {
    title:
      "What Are the Costs When Buying a House? Understanding the Hidden Expenses",
    image: blog2,
    datePosted: "Apr 23, 2025",
    description:
      "When you’re planning to buy a home, it’s easy to focus on the price of the property itself. However, there are numerous additional costs involved that can catch you by surprise if you’re not prepared. From solicitors' fees and stamp duty to home surveys and removals,...",
    link: "/blogs2",
  },
  {
    title: "Low-Deposit Mortgages Reach 17-Year High: What It Means for You",
    image: blog1,
    datePosted: "Apr 16, 2025",
    description:
      "In a significant development for the UK housing market, the number of low-deposit mortgage deals—requiring just a 5% or 10% deposit—has reached its highest level since 2008.  Your home may be repossessed if you do not keep up repayments on your mortgage Information...",
    link: "/blogs1",
  },

];

const BlogsPage = () => {
  return (
    <div className="home-page">
      <Hero
        title="Blogs"
        titleAlign="center"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="center"
        lightOverlay={true}
      />
      <div className="white-container">
        <div className="white-container-content">
          <div className="cards-wrapper" style={{ padding: "2rem 0" }}>
            {blogs.map((blog, idx) => (
              <BlogCard key={idx} {...blog} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogsPage;
